import { render, staticRenderFns } from "./OrderReturn.vue?vue&type=template&id=980f4426&scoped=true&"
import script from "./OrderReturn.vue?vue&type=script&lang=js&"
export * from "./OrderReturn.vue?vue&type=script&lang=js&"
import style0 from "./OrderReturn.vue?vue&type=style&index=0&id=980f4426&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980f4426",
  null
  
)

export default component.exports